import React from 'react';
import { makeStyles } from '@material-ui/styles';
import AutocompleteGoogle from "react-google-autocomplete";
import { formatMs, Paper, Typography } from '@material-ui/core';

import LocationSearchingRoundedIcon from '@material-ui/icons/LocationSearchingRounded';
import LocationCityRoundedIcon from '@material-ui/icons/LocationCityRounded';
import {colors} from  '../colors/colors.js'; 
import {useState, useEffect, useCallback, useRef} from 'react'
import { LocationOn } from '@material-ui/icons';

/**
 *  ref 
 * https://www.npmjs.com/package/react-google-autocomplete
 * 
 * https://developers.google.com/maps/documentation/javascript/examples/map-geolocation
 * 
 * https://developers.google.com/maps/documentation/javascript/overview?hl=es-419#js_api_loader_package
 * 
 */
const useStyles = makeStyles((theme) => ({

  autocompletePaper: {
  
    //backgroundColor: theme.palette.background.paper,
    border: 0,
    height:"auto",
    paddingLeft:  theme.spacing(1),
    paddingRight:  theme.spacing(1),
    paddingBottom: theme.spacing(1),
    width: "100%",
  },

   autocompleteInput: {
    display: 'flex', 
    justifyContent: 'center',
    alignItems:'center',
    width: "100%",
    border: "none",
    borderRadius: "0.5rem",
    placeHolder:"Address",
    backgroundColor: colors.grayBackground, 
    paddingLeft:"0.3rem",
    paddingRight:"0.3rem",
    marginTop:"0.5rem",
    marginBottom:"0.3rem",
  
  }, 
  inputDetails:{
    width: "100%",
    border: "none",
    paddingTop: "0.7rem",
    paddingBottom: "0.7rem",
    placeHolder:"Address",
    marginLeft:"0.5rem",
    marginRight:"1rem", 
    backgroundColor: 'disabled', 
    outline:'none', 
    fontSize: '1.0rem',
    backgroundColor: colors.grayBackground
  },

  inputHelp: {
    fontSize: '0.8rem',
    color:  colors.textSecundary, 
    marginBottom: '0.5rem',
    marginLeft:'0.5rem',
  },

  title: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems:'center',
    textTransform: 'uppercase',
    fontSize: '0.8rem',
    padding: theme.spacing(1),
   },

}));


const autocompleteGoogle={
  width: "100%",
  height: "auto",
  border: "none",
  paddingTop: "0.7rem",
  paddingBottom: "0.7rem",
  placeHolder:"Address",
  marginLeft:"0.5rem",
  marginRight:"1rem", 
  backgroundColor: colors.grayBackground, 
  outline:'none', 
  fontSize: '1.0rem',
  //overflowWrap: 'break-word !important',
  //whiteSpace: 'pre-line !important'
}

export default function AutoCompleteAddress(props) {
 
  const classes = useStyles();

  const {
    onSelectedAddress,
    onChangeDetailsInput,
     onChangeInput,
      onClickInput,
      fullAddress, 
      bounds, 
      strings, 
      autoIconColor,
      autoTitle, 
    } = props; 

   const title = autoTitle?autoTitle:strings.address_page_title; 

  
  const handlerOnClick = ()=>{
    onClickInput();
  }; 

  const handlerOnChange = (event)=>{
    onChangeInput(event.target.value);
  }

  const handlerOnChangeDetails = (event)=>{
    onChangeDetailsInput(event.target.value);
  }

  const handlerOnSelected = (place)=>{  
    onSelectedAddress(place);
    const details = document.querySelector('#detailsId');
    details.focus(); 
   }

  
  return (
    <div className={classes.autocompletePaper}  >
 
        {title && 
          <Typography className={classes.title}>{title}</Typography>
        }    
 <Typography className={classes.inputHelp } variant='caption'>{strings.help_place}</Typography>
        <div className={classes.autocompleteInput}>

            {
             <LocationOn color={autoIconColor}/>
            }
            {<AutocompleteGoogle
          apiKey={"AIzaSyCtbhzjXJz1mToDtw3UW7LsQRnYq1Q5rtQ"}
                        autoFocus = {!fullAddress}
                        style={autocompleteGoogle}
                      
                        onClick = {handlerOnClick}
                        onChange= {handlerOnChange}
                        placeholder={strings.hint_seach_addrees}
                        onPlaceSelected={ handlerOnSelected }
                        options={{
                          types: ["address"],
                          bounds: bounds,
                        }}     
                        value = {fullAddress? fullAddress.address:""}                
                />
              }
        </div> 
         
            {  <div className={classes.autocompleteInput}>
                <LocationCityRoundedIcon color='disabled' />
                <input 
                  id="detailsId"
                  autoComplete="off"
                  className={classes.inputDetails} 
                  type="text" 
                  placeholder={strings.hint_details}
                  onChange = {handlerOnChangeDetails}
                  value = {fullAddress? fullAddress.details:""}  
                />
                
                </div>
              }
           <Typography  className={classes.inputHelp } variant='caption' >{strings.help_details}</Typography>
      </div> 
  );
}